import { render } from "./fail-tv360-dialog.vue?vue&type=template&id=a432b0de"
import script from "./fail-tv360-dialog.vue?vue&type=script&lang=js"
export * from "./fail-tv360-dialog.vue?vue&type=script&lang=js"

import "./fail-tv360-dialog.vue?vue&type=style&index=0&id=a432b0de&lang=scss"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__